import React from 'react'

const ContentLayoutHOC = Component => props => (
  <main id="content" className="contentpush audioplayer fadein">
    <Component {...props} />
  </main>
)

export default ContentLayoutHOC
